
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { warn } from "vue-class-component/lib/util";
import httpClient from "./store/httpClient";

@Component
export default class App extends Vue {
	@Prop()
	private msg!: string;
	private drawer: boolean = false;
	private snackbar: boolean = false;

	private mounted() {
		this.loadTags();
	}

	private get username() {
		return this.$store.state.oidc.user.profile.name.toLowerCase();
	}

	private get snackbarText() {
		return this.$store.state.snackbarText;
	}

	private get snackbarColor() {
		return this.$store.state.snackbarColor;
	}

	private get embedded() {
		const boolValue = this.$store.state.embedded === "true";
		return boolValue;
	}

	@Watch("snackbarText")
	private showSnackbar() {
		const text = this.snackbarText;
		if (text !== null && text !== "") {
			this.snackbar = true;
			setTimeout(() => {
				this.$store.commit("setSnackbarText", "");
			}, 6000);
		}
		return text;
	}

	private navigateTo(to: string) {
		this.$router.push({ name: to });
	}

	private logout() {
		this.$store.dispatch("logout");
	}

	private async loadTags() {
		try {
			const response = await httpClient().get(`Customer/GetTags`);
			this.$store.commit("setTags", response.data);
		} catch {
			console.log("Load tags failed.");
		}
	}
}
